import React, { useEffect, useMemo } from "react";
import { Button, Grid, InputLabel, OutlinedInput, Paper, SpeedDial } from "@mui/material";
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { DataGrid } from '@mui/x-data-grid';
import { usePrestacaoContasState } from "./context/prestacao-contas-context";
import { usePrestacaoContasController } from "./context/prestacao-contas-controller";
import { PrestacaoContasDrawer } from "./components/prestacao-contas-drawer";
import { getDataGridLocaleText, dataGridDefaultSx, dataGridDefaultProps } from "../../../config/datagrid-config";

export const PrestacaoContas = () => {
    const { dataPaginatedListResponse, isLoadingData, dataSearchRequest } = usePrestacaoContasState();
    const { loadData, onChangePagination, handleOnChangeSearch, clearFields, getColumnsGrid, openForm } = usePrestacaoContasController();

    useEffect(() => {
        (async () => {
            await loadData(dataSearchRequest);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const paginationModel = useMemo(() => ({
        page: dataSearchRequest?.page ?? 0,
        pageSize: dataPaginatedListResponse?.pageSize ?? 10
    }), [dataSearchRequest?.page, dataPaginatedListResponse?.pageSize]);

    return (
        <React.Fragment>
            <PrestacaoContasDrawer />

            <Grid item xs={12} md={12} lg={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Grid container spacing={1.5}>
                        <Grid item lg={8} sm={8} xl={8}>
                            <InputLabel>Buscar por descrição</InputLabel>
                            <OutlinedInput
                                size="small"
                                value={dataSearchRequest?.term}
                                onChange={handleOnChangeSearch}
                                fullWidth
                            />
                        </Grid>
                        <Grid item lg={2} sm={2} xl={2} sx={{ mt: 1, display: 'flex', flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>
                            <Button variant="contained" fullWidth size="small" onClick={async () => await loadData(dataSearchRequest)} startIcon={<SearchIcon />}>
                                Consultar
                            </Button>
                        </Grid>
                        <Grid item lg={2} sm={2} xl={2} sx={{ mt: 1, display: 'flex', flexDirection: "column", justifyContent: "flex-end", alignItems: "flex-end" }}>
                            <Button variant="outlined" fullWidth size="small" onClick={clearFields} startIcon={<ClearIcon />}>
                                Limpar
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper sx={{ p: 2, minHeight: "500px", display: 'flex', flexDirection: 'column' }}>
                    <DataGrid
                        rows={dataPaginatedListResponse.items}
                        columns={getColumnsGrid()}
                        {...dataGridDefaultProps}
                        onPaginationModelChange={(e) => onChangePagination(e.page, e.pageSize)}
                        sx={dataGridDefaultSx}
                        localeText={getDataGridLocaleText(dataPaginatedListResponse.totalRecords, dataPaginatedListResponse.pageSize)}
                        paginationModel={paginationModel}
                        rowCount={dataPaginatedListResponse.totalRecords}
                        loading={isLoadingData}
                    />
                    <SpeedDial
                        ariaLabel="Nova Prestação de Contas"
                        sx={{ position: 'absolute', bottom: 16, right: 16 }}
                        onClick={() => openForm()}
                        icon={<SpeedDialIcon />}
                    />
                </Paper>
            </Grid>
        </React.Fragment>
    );
};
